export default "__VITE_ASSET__CJsU51Ny__"